import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AcademicYearWarning {
  show: boolean;
  yearName: string;
  isActive: boolean;
}

export interface AcademicYearState {
  academicYearId: string | number;
  academicYearName: string;
  isCurrentYear: boolean;
  schoolId: string;
}

@Injectable({
  providedIn: 'root'
})
export class AcademicYearBadgeService {
  // ✅ BehaviorSubject for warning banner
  private academicYearWarningSubject = new BehaviorSubject<AcademicYearWarning>({
    show: false,
    yearName: '',
    isActive: true
  });
  public academicYearWarning$ = this.academicYearWarningSubject.asObservable();

  // ✅ BehaviorSubject for academic year state (replaces interceptor)
  private academicYearStateSubject = new BehaviorSubject<AcademicYearState | null>(null);
  public academicYearState$ = this.academicYearStateSubject.asObservable();

  // ✅ BehaviorSubject for year change notifications
  private academicYearChangeSubject = new BehaviorSubject<string | number | null>(null);
  public academicYearChange$ = this.academicYearChangeSubject.asObservable();



  private refreshDataSubject = new BehaviorSubject<boolean>(false);
  public refreshData$ = this.refreshDataSubject.asObservable();


  constructor() {}

  // ✅ Initialize academic year state
  initializeAcademicYear(state: AcademicYearState): void {
    this.academicYearStateSubject.next(state);
  }

  // ✅ Get current academic year ID synchronously
  getCurrentAcademicYearId(): string | number | null {
    return this.academicYearStateSubject.value?.academicYearId || null;
  }

  // ✅ Get current academic year state synchronously
  getCurrentAcademicYearState(): AcademicYearState | null {
    return this.academicYearStateSubject.value;
  }

  // ✅ Update academic year (replaces session update + interceptor)
  updateAcademicYear(state: AcademicYearState): void {
    this.academicYearStateSubject.next(state);
    this.notifyAcademicYearChange(state.academicYearId);
  }

  // ✅ Notify components of year change
  notifyAcademicYearChange(yearId: string | number): void {
    this.academicYearChangeSubject.next(yearId);
  }

  // ✅ Update warning banner
  updateWarning(warning: AcademicYearWarning): void {
    this.academicYearWarningSubject.next(warning);
  }

  // ✅ Hide warning banner
  hideWarning(): void {
    this.academicYearWarningSubject.next({
      show: false,
      yearName: '',
      isActive: true
    });
  }

  // ✅ Reset state (for logout)
  resetState(): void {
    this.academicYearStateSubject.next(null);
    this.academicYearChangeSubject.next(null);
    this.hideWarning();
  }

    triggerDataRefresh(): void {
    this.refreshDataSubject.next(true);
  }
}